import styled from 'styled-components';

export const TileChildrenContainer = styled.div`
  width: inherit;
  margin: 0 25px;
  height: fit-content;
  padding: 12px 0 0 12px;
`;
